import config from 'configAlias';
import get from 'lodash/get';
import has from 'lodash/has';
import isBoolean from 'lodash/isBoolean';
import isString from 'lodash/isString';
import { getQueryStringValueByKey } from './url';

export const getFeatureFlag = ({ config = false, env, query = '' }) => {
  const queryValue =
    typeof window !== 'undefined' && getQueryStringValueByKey(query);

  if (isString(queryValue)) {
    return queryValue === 'true';
  }

  if (isBoolean(env)) {
    return env;
  }

  return config;
};

export const checkFeatureFlag = (item = {}) => {
  const globalContext = typeof window === 'undefined' ? {} : window;

  const allowedFlags = {
    __DIVA_ENABLED__: get(globalContext, '__DIVA_ENABLED__'),
    __DIVA_DCO_ENABLED__: get(globalContext, '__DIVA_DCO_ENABLED__'),
    __TRIAGE_ENABLED__: get(globalContext, '__TRIAGE_ENABLED__'),
    __TEST_DIVA__: get(globalContext, '__TEST_DIVA__'),
  };

  const isNotFlag = has(item, 'not');
  const envFlag = allowedFlags[get(item, `${isNotFlag ? 'not.' : ''}env`)];

  const isFeatureFlag = getFeatureFlag({
    query: get(item, `${isNotFlag ? 'not.' : ''}query`, null),
    env: typeof envFlag === 'string' ? envFlag === 'true' : undefined,
    config: get(
      config,
      get(item, `${isNotFlag ? 'not.' : ''}configPath`),
      false
    ),
  });

  return isNotFlag ? !isFeatureFlag : isFeatureFlag;
};

export const parseFeatureFlagsConfig = (featureFlagsConfig = {}) =>
  Object.keys(featureFlagsConfig).reduce((acc, key) => {
    acc[key] = checkFeatureFlag(featureFlagsConfig[key]);
    return acc;
  }, {});
